<template>
  <div class="loading" v-show="loading">
    <img src="@/assets/images/loading.svg" />
  </div>
</template>

<script>
import { mapState } from 'vuex';
export default {
  name: 'Loading',
  computed: {
    ...mapState('common', {
      loading: state => state.loading
    })
  }
};
</script>

<style scoped lang="scss">
/* 화면 중앙 배치를 위한 CSS */
.loading {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 89;
}
</style>
